export default __webpack_public_path__ + "static/illustration-10th-grade-176959014de8be767de1530cad896490.svg";